import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import { SUPPORTED_BROWSERS } from "../constants";
export default {
  methods: {
    recommendedBrowser() {
      const currentBrowser = navigator.sayswho;
      return SUPPORTED_BROWSERS.some(browser => _includesInstanceProperty(currentBrowser).call(currentBrowser, browser.name) && browser.recommended);
    }
  }
};